import React, { useState } from "react";
import ReactDOM from "react-dom";
import "react-icons/ai";
import { AiOutlineWarning } from "react-icons/ai";
import { extendSession } from "../actions/adminActions";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
const Modal = ({ time, setSession, countDownTimer, timer }) => {
  const [loading, setLoading] = useState(false);
  if (!time) return null;
  const extendTime = async () => {
    setLoading(true);
    clearInterval(countDownTimer);
    const sessionTime = {
      session: new Date(new Date().getTime() + 1 * 60000),
    };
    await extendSession(sessionTime);
    setLoading(false);
    toast.success("Successfully extended session");
    timer(sessionTime.session);
    setSession({ time: false });
  };
  return ReactDOM.createPortal(
    <div className="modal-container">
      <div className="modal">
        <div className="warning">
          <AiOutlineWarning className="warning-logo" />
          <div className="warning-text">
            <h6 className="expire-title">Your session is about to expire!</h6>
            <p className="expire-content">
              You will be logged out in <b>{time}</b> seconds left Do you want
              to stay signed in?`
            </p>
          </div>
        </div>

        <div className="row">
          <button onClick={() => extendTime()}>
            {" "}
            {loading ? (
              <div>
                <FontAwesomeIcon icon={faCog} className="fa-spin" />
                {"Yes, keep me signed in"}
              </div>
            ) : (
              "Yes, keep me signed in"
            )}
          </button>
          <button>No, Sign me out</button>
        </div>
      </div>
    </div>,
    document.getElementById("modal")
  );
};

export default Modal;
